import { combineReducers } from "redux";
import { ELANGUAGEKEYS } from "../utils/Enums/ELanguageKeys";

export enum ETimeSpan {
    DAY = "day",
    WEEK = "week",
    MONTH = "month",
    YEAR = "year",
    ALL = "all",
}

function setPrimaryProfileObject(state = {}, action: { type: string; primary_profile: {} }) {
    switch (action.type) {
        case "SET_PRIMARY_PROFILE":
            return {
                ...state,
                primary_profile: action.primary_profile,
            };
        default:
            return state;
    }
}

const isProfileFetched = (state = false, action: { type: string; isProfileFetched: boolean }) => {
    switch (action.type) {
        case "IS_PROFILE_FETCHED":
            return action.isProfileFetched;
        default:
            return state;
    }
};

const setProfileImage = (state = "", action: { type: string; profileImage: string }) => {
    switch (action.type) {
        case "SET_PROFILE_IMAGE":
            return action.profileImage;
        default:
            return state;
    }
};

const areProfileImageFetched = (state = false, action: { type: string; areProfileImageFetched: boolean }) => {
    switch (action.type) {
        case "ARE_PROFILE_IMAGE_FETCHED":
            return action.areProfileImageFetched;
        default:
            return state;
    }
};

const isPrimaryProfileFetched = (state = false, action: { type: string; isPrimaryProfileFetched: boolean }) => {
    switch (action.type) {
        case "IS_PRIMARY_PROFILE_FETCHED":
            return action.isPrimaryProfileFetched;
        default:
            return state;
    }
};

const setFamilyUserId = (state = null, action: { type: string; family_user_id: number }) => {
    switch (action.type) {
        case "SET_FAMILY_USER_ID":
            return action.family_user_id;
        default:
            return state;
    }
};

const setFamilyJioId = (state = "", action: { type: string; family_jio_id: string }) => {
    switch (action.type) {
        case "SET_FAMILY_JIO_ID":
            return action.family_jio_id;
        default:
            return state;
    }
};

const setFamilyMobileNo = (state = "", action: { type: string; family_mobile_no: string }) => {
    switch (action.type) {
        case "SET_FAMILY_MOBILE_NO":
            return action.family_mobile_no;
        default:
            return state;
    }
};

const setFamilyMPIN = (state = "", action: { type: string; family_mpin: string }) => {
    switch (action.type) {
        case "SET_FAMILY_MPIN":
            return action.family_mpin;
        default:
            return state;
    }
};

function cartCount(state = 0, action: { type: string; cart_count: number }) {
    switch (action.type) {
        case "GET_ITEMS_COUNT":
            return action.cart_count;
        default:
            return state;
    }
}

function setServiceProviderId(state = 0, action: { type: string; id: number }) {
    switch (action.type) {
        case "UPDATE_PARTNER_ID":
            return action.id;
        default:
            return state;
    }
}

function NextEnabledDate(state = "", action: { type: string; nextDate: string }) {
    switch (action.type) {
        case "SET_ENABLED_DATE":
            return action.nextDate;
        default:
            return state;
    }
}

function SelectedDate(state = "", action: { type: string; selectedDate: string }) {
    switch (action.type) {
        case "SET_SELECTED_DATE":
            return action.selectedDate;
        default:
            return state;
    }
}

function PayableCharge(state = null, action: { type: string; PayableCharge: number }) {
    switch (action.type) {
        case "SET_PAYABLE_CHARGE":
            return action.PayableCharge;
        default:
            return state;
    }
}

function SpecialDiscountValue(state = null, action: { type: string; discountValue: number }) {
    switch (action.type) {
        case "DISCOUNT_VALUE":
            return action.discountValue;
        default:
            return state;
    }
}

function subTotal(state = null, action: { type: string; subtotal: number }) {
    switch (action.type) {
        case "SUBTOTAL_VALUE":
            return action.subtotal;
        default:
            return state;
    }
}

function defaultAddress(state = null, action: { type: string; address: string }) {
    switch (action.type) {
        case "SET_ADDRESS":
            return action.address;
        default:
            return state;
    }
}

function addressId(state = null, action: { type: string; addressId: string }) {
    switch (action.type) {
        case "SET_ADDRESS_ID":
            return action.addressId;
        default:
            return state;
    }
}

function pincode(state = null, action: { type: string; pincode: string }) {
    switch (action.type) {
        case "SET_PINCODE":
            return action.pincode;
        default:
            return state;
    }
}

function cityName(state = null, action: { type: string; cityName: string }) {
    switch (action.type) {
        case "SET_CITYNAME":
            return action.cityName;
        default:
            return state;
    }
}

function packageIds(state = null, action: { type: string; packageIds: string }) {
    switch (action.type) {
        case "SET_PACKAGEID":
            return action.packageIds;
        default:
            return state;
    }
}

function currentProfile(state = null, action: { type: string; jioId: string }) {
    switch (action.type) {
        case "SET_CURRENT_PROFILE":
            return action.jioId;
        default:
            return state;
    }
}

const _setCurrentProfileData = (state = null, action: { type: string; current_profile_data: {} }) => {
    switch (action.type) {
        case "SET_CURRENT_PROFILE_DATA":
            return action.current_profile_data;
        default:
            return state;
    }
};

const _setPrimaryProfileRelationshipArray = (state = null, action: { type: string; ppra: {} }) => {
    switch (action.type) {
        case "SET_PRIMARY_PROFILE_RELATIONSHIP_ARRAY":
            return action.ppra;
        default:
            return state;
    }
};

const SmartSwitchCompleted = (
    state = { completed: false, location: null, smartSwitchUrlArray: null },
    action: { type: string; status: {} }
) => {
    switch (action.type) {
        case "UPDATE_SMART_SWITCH_STATUS":
            return action.status;
        default:
            return state;
    }
};

const BookAppointmentFilterData = (state = null, action: { type: string; filterData: {} }) => {
    switch (action.type) {
        case "UPDATE_BOOK_APPOINTMENT_FILTER_DATA":
            return action.filterData;
        default:
            return state;
    }
};

const HelpAndSupportOpen = (state = false, action: { type: string; status: boolean }) => {
    switch (action.type) {
        case "UPDATE_HELP_AND_SUPPORT_OPEN_STATUS":
            return action.status;
        default:
            return state;
    }
};

const _setLanguageClick = (state = ELANGUAGEKEYS.ENGLISH, action: { type: string; languageKey: string }) => {
    switch (action.type) {
        case "SET_LANGUAGE_CLICK":
            return action.languageKey;
        default:
            return state;
    }
};

const _getTimeSpan = (state = 1, action: { type: string; payload: number }) => {
    switch (action.type) {
        case "SET_TIME_SPAN_ID":
            return action.payload;
        default:
            return state;
    }
};

const _getPreviousDate = (state = new Date().toISOString().slice(0, 10), action: { type: string; payload: string }) => {
    switch (action.type) {
        case "SET_PREVIOUS_DATE":
            return action.payload;
        default:
            return state;
    }
};

const rootReducer = combineReducers({
    setPrimaryProfileObject,
    isProfileFetched,
    isPrimaryProfileFetched,
    setFamilyUserId,
    setFamilyJioId,
    setFamilyMPIN,
    setFamilyMobileNo,
    cartCount,
    setServiceProviderId,
    NextEnabledDate,
    SelectedDate,
    PayableCharge,
    SpecialDiscountValue,
    subTotal,
    defaultAddress,
    addressId,
    pincode,
    cityName,
    packageIds,
    currentProfile,
    setProfileImage,
    areProfileImageFetched,
    _setCurrentProfileData,
    _setPrimaryProfileRelationshipArray,
    SmartSwitchCompleted,
    BookAppointmentFilterData,
    HelpAndSupportOpen,
    _setLanguageClick,
    _getTimeSpan,
    _getPreviousDate,
});

export default rootReducer;
